<template>
  <div class="animated fadeIn">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col sm="12" class="title">
        <h3 class="mb-4">Relatório Consolidado de Usuários</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button variant="primary" class="form-control" @click="getData">Visualizar</b-button>
              </b-col>
              <b-col sm="12" lg="2">
                <b-button variant="secondary" class="form-control" @click="download">Download</b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="items && items.length > 0">
      <b-col sm="12">
        <b-table id="result-table" :hover="true" :striped="true" :bordered="false" :small="false" :fixed="false" responsive="sm"
          :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage">
          <template slot="userClass" slot-scope="data">{{getUserClassLabel(data.item.userClass)}}</template>
        </b-table>
        <b-pagination v-if="items.length > 0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="result-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { requestError, env, formatDate } from '@/shared/utils'
import _ from 'underscore'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'report_users',
  components: {
    Loading
  },
  data: function() {
    return {
      items: [],
      perPage: 30,
      currentPage: 1,
      loadCount: 0,
    }
  },
  computed: {
    ...mapState(['corporationSelected']),
    isLoading() {
      return this.loadCount > 0;
    },
    fields() {
      let fields = [];
      if (this.items && this.items.length > 0 && this.items[0].corporation_name) {
        fields.push({key: 'corporation_name', label: 'Corporação'})
      }
      fields.push(...[
        {key: 'cnpj', label: 'CNPJ'},
        {key: 'userClass', label: 'Tipo de Usuário'},
        {key: 'users_count', label: 'Usuários'},
      ])
      return fields;
    },
    rows() {
      return this.items ? this.items.length : 0;
    }
  },
  methods: {
    
    async getData() {
      var _this = this;
      this.loadCount++;
      await axios
        .get(this.getUrl())
        .then(function(response) {
          _this.items = response.data._embedded.corporation_user_report;
          console.log(response.data);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    async download () {
      var _this = this;
      this.loadCount++;
      var format = "csv";
      await axios
        .get(this.getUrl(format),
          { responseType: 'arraybuffer' })
        .then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `corporation-user-report-${+ new Date()}.${format}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    getUserClassLabel(userClass) {
      switch (userClass) {
        case 'user_signer':
          return "Assinante PJ"
        default:
          return "Corporativo"
      }
    },
    getUrl(format = null) {
      let url = `${env.urlBillingApi}/corporation-user-report`;
      if (format) {
        url += `?report=true&format=${format}`;
      }
      return url;
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
</style>

<style scoped>
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>